import type { State } from '../../state/types.tsx';
import {
	USER_FILTER_ID,
	type UserFilter,
} from '../../state/ui/top/title-bar/update-jira/types.tsx';

export const getUserFilter = (state: State): UserFilter =>
	state.ui.Top.TitleBar.UpdateJira.filters[USER_FILTER_ID];
